import { push } from 'connected-react-router';
import { msToHMS } from './utils';
import { APP_INIT } from '../helpers/serverRenderingUtils';
import AnchorAPI from './modules/AnchorAPI';

export const RECEIVE_PODCAST_EPISODES = '@@podcast/RECEIVE_PODCAST_EPISODES';
export const RECEIVE_PODCAST_EPISODE_TOTAL =
  '@@podcast/RECEIVE_PODCAST_EPISODE_TOTAL';

export const SET_IS_PLAYING = '@@podcast/SET_IS_PLAYING';
export const SET_IS_ACTIVE = '@@podcast/SET_IS_ACTIVE';

const initialState = {
  podcastEpisodeTotal: 0,
  podcastEpisodes: [],
};

const initialEpisodeState = {
  isActive: false,
  isPlaying: false,
};

// reducers

function podcastEpisodeReducer(state = initialEpisodeState, action) {
  switch (action.type) {
    case APP_INIT:
    case RECEIVE_PODCAST_EPISODES: {
      const {
        createdUnixTimestamp,
        duration,
        isPublished,
        publishOnUnixTimestamp,
      } = state;
      return {
        ...state,
        created: createdUnixTimestamp && new Date(createdUnixTimestamp * 1000),
        durationHMS: msToHMS(duration),
        isDraft: !isPublished,
        publishOn:
          publishOnUnixTimestamp && new Date(publishOnUnixTimestamp * 1000),
      };
    }
    case SET_IS_ACTIVE: {
      const { podcastEpisodeId, isActive } = action.payload;
      if (podcastEpisodeId === state.podcastEpisodeId) {
        return {
          ...state,
          isActive,
        };
      }
      // note - currently don't support showing multiple active progress bars / it is a singleton state
      return {
        ...state,
        isActive: false,
      };
    }
    case SET_IS_PLAYING: {
      const { podcastEpisodeId, isPlaying } = action.payload;
      if (podcastEpisodeId === state.podcastEpisodeId) {
        return {
          ...state,
          isPlaying,
        };
      }
      return state;
    }
    default:
      return state;
  }
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PODCAST_EPISODE_TOTAL: {
      const { podcastEpisodeTotal } = action.payload;
      return {
        ...state,
        podcastEpisodeTotal,
      };
    }
    case APP_INIT: {
      // SSR
      const { podcastEpisodes } = state;
      return {
        ...state,
        podcastEpisodes: podcastEpisodes.map(e =>
          podcastEpisodeReducer(e, action)
        ),
      };
    }
    case RECEIVE_PODCAST_EPISODES: {
      const { podcastEpisodes } = action.payload;
      return {
        ...state,
        podcastEpisodes: podcastEpisodes.map(e =>
          podcastEpisodeReducer(e, action)
        ),
      };
    }
    case SET_IS_ACTIVE:
    case SET_IS_PLAYING: {
      const { podcastEpisodes } = state;
      return {
        ...state,
        podcastEpisodes: podcastEpisodes.map(e =>
          podcastEpisodeReducer(e, action)
        ),
      };
    }
    default:
      return state;
  }
}

// action creators

export function receivePodcastEpisodes(podcastEpisodes) {
  return {
    type: RECEIVE_PODCAST_EPISODES,
    payload: {
      podcastEpisodes,
    },
  };
}

export function receivePodcastEpisodeTotal(podcastEpisodeTotal) {
  return {
    type: RECEIVE_PODCAST_EPISODE_TOTAL,
    payload: {
      podcastEpisodeTotal,
    },
  };
}

export function setIsActive(isActive, podcastEpisodeId) {
  return {
    type: SET_IS_ACTIVE,
    payload: {
      isActive,
      podcastEpisodeId,
    },
  };
}

export function setIsPlaying(isPlaying, podcastEpisodeId) {
  return {
    type: SET_IS_PLAYING,
    payload: {
      isPlaying,
      podcastEpisodeId,
    },
  };
}

// thunks

/**
 * Only for 'Switch to Anchor' users
 */

export function fetchMyPodcastEpisodes(page = 1, limit = 10) {
  return (dispatch, getState) => {
    return AnchorAPI.fetchPodcastEpisodes(page, limit)
      .then(responseJson => {
        const { podcastEpisodes, totalPodcastEpisodes } = responseJson;
        dispatch(receivePodcastEpisodes(podcastEpisodes));
        dispatch(receivePodcastEpisodeTotal(totalPodcastEpisodes));
        return podcastEpisodes;
      })
      .catch(error => {
        if (error.status === 401) {
          // not logged in
          return dispatch(push('/login'));
        }
        // e.g. no permissions (403)
        return dispatch(push('/404'));
      });
  };
}
